import {
  faInfoCircle,
  faKey,
  faPencilAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { Badge, Button } from "reactstrap";
import moment from "moment";
import { utils } from "../../../../utils/utils";

const DATE_DISPLAY = "MMM D, h:mm a";

const pickKeyPrefix = (k) => {
  const p = k.keyPrefix ?? k.prefix ?? k.keyIdPrefix;
  if (p != null && String(p).length > 0) {
    return String(p);
  }
  return null;
};

const formatCreated = (v) => {
  if (v == null || v === "") {
    return "—";
  }
  if (!moment(v).isValid()) {
    return "—";
  }
  return utils.formatDateTime(v, DATE_DISPLAY);
};

/**
 * @param {function(object): void} onDetails
 * @param {function(object): void} onRevoke
 * @param {function(object): void} onEdit
 */
export const customerApiKeysColumns = (onDetails, onRevoke, onEdit) => [
  {
    accessor: "name",
    Header: "Name",
    disableSortBy: true,
    width: 200,
    headerProps: { className: "text-truncate" },
    cellProps: { className: "text-truncate" },
    Cell: (rowData) => {
      const k = rowData.row.original;
      return (
        <span className="d-flex align-items-center small">
          <FontAwesomeIcon
            icon={faKey}
            className="text-primary mr-2 flex-shrink-0"
            size="sm"
            title="API key"
          />
          {k.name || "—"}
        </span>
      );
    },
  },
  {
    id: "keyMask",
    accessor: (row) => pickKeyPrefix(row) ?? "",
    Header: "Key",
    disableSortBy: true,
    width: 200,
    headerProps: { className: "text-truncate" },
    cellProps: { className: "text-truncate" },
    Cell: (rowData) => {
      const k = rowData.row.original;
      const prefix = pickKeyPrefix(k);
      if (prefix) {
        return (
          <span className="small font-weight-bold">
            {prefix}
            <span className="text-muted">***</span>
          </span>
        );
      }
      return <span className="text-muted">—</span>;
    },
  },
  {
    id: "active",
    Header: "Active",
    disableSortBy: true,
    width: 100,
    headerProps: { className: "text-truncate" },
    cellProps: { className: "text-nowrap" },
    Cell: (rowData) => {
      const isActive = rowData.row.original.isActive !== false;
      return isActive ? (
        <Badge color="success" className="px-2" pill>
          Yes
        </Badge>
      ) : (
        <Badge color="danger" className="px-2" pill>
          No
        </Badge>
      );
    },
  },
  {
    accessor: "customerId",
    Header: "Customer",
    disableSortBy: true,
    width: 220,
    headerProps: { className: "text-truncate" },
    cellProps: { className: "text-truncate" },
    Cell: (rowData) => {
      const k = rowData.row.original;
      const { customerId } = k;
      if (customerId == null) {
        return "—";
      }
      return (
        <Link
          to={`/customers/${customerId}/details`}
          className="font-weight-medium small"
        >
          {k.customerName || `Customer #${customerId}`}
        </Link>
      );
    },
  },
  {
    accessor: "createdAt",
    Header: "Created",
    disableSortBy: true,
    width: 150,
    headerProps: { className: "text-truncate" },
    cellProps: { className: "text-truncate" },
    Cell: (rowData) => {
      return (
        <span className="small text-break">
          {formatCreated(rowData.row.original.createdAt)}
        </span>
      );
    },
  },
  {
    id: "actions",
    Header: "Actions",
    disableSortBy: true,
    width: 220,
    headerProps: { className: "text-truncate text-center" },
    cellProps: { className: "text-left text-nowrap" },
    Cell: (rowData) => {
      const k = rowData.row.original;
      const isActive = k.isActive !== false;
      return (
        <div className="d-flex flex-nowrap align-items-center">
          <Button
            color="secondary"
            size="sm"
            outline
            className="d-flex align-items-center"
            onClick={() => onDetails(k)}
          >
            <FontAwesomeIcon icon={faInfoCircle} className="mr-1" />
            Details
          </Button>
          {isActive && k.id != null ? (
            <Button
              color="warning"
              size="sm"
              outline
              className="ml-2 d-flex align-items-center"
              onClick={() => onEdit(k)}
            >
              <FontAwesomeIcon icon={faPencilAlt} className="mr-1" />
              Edit
            </Button>
          ) : null}
          {isActive && k.id != null ? (
            <Button
              color="danger"
              size="sm"
              className="ml-2"
              onClick={() => onRevoke(k)}
            >
              Revoke
            </Button>
          ) : null}
        </div>
      );
    },
  },
];
